import { render, staticRenderFns } from "./IconDocumentDownloadSolid.vue?vue&type=template&id=67dafd94"
import script from "./IconDocumentDownloadSolid.vue?vue&type=script&lang=js"
export * from "./IconDocumentDownloadSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports